import React, { useEffect } from "react"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { home } from "../../routes"
import { useStore } from "../../state/store"
import "./Landing.css"

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

function Landing() {
  const loaded = useStore(state => state.loaded)

  useEffect(() => {
    // console.log("loaded", loaded)
  }, [loaded])

  return (
    <motion.div
      className="landing"
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
    >
      <div className="overlap-wraper">
        <div className="logo">
          {/* <h1>POSTMARK</h1> */}
          <img src="/assets/images/landing/FolioGardens_Postmark.svg" alt=""></img>
        </div>
        <div
          // className="enter-link"
          style={{
            cursor: "auto",
            position: "absolute",
            display: "flex",
            top: "67%",
            width: "6em",
            height: "6em",
            marginTop: "7em"
          }}
          onClick={() => console.log("object")}
        >
          {!loaded && (
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          )}
        </div>
      </div>
      <div className="overlap-wraper">
        {loaded && (
          <Link to={home.path} className="enter-link">
            <img src="/assets/images/landing/circle_arrow.svg" alt=""></img>
          </Link>
        )}
      </div>
      <div className="video-wraper">
        {/* <ReactPlayer
          url={VideoURL}
          playsinline={true}
          loop={true}
          playing={true}
          controls={false}
          muted={true}
        ></ReactPlayer> */}
      </div>
    </motion.div>
  )
}

export default Landing
